import { Box, Chip, Typography } from "@mui/material";
import { baseTheme } from "../../../themes/shipinsure";
import { formatMoney } from "../getStatusViewModel";

const META_TEXT = "#1E293B";

function getItemStatus(item, claim) {
  if (item.actual_resolution) {
    return "approved";
  }

  if (["approved", "closed"].includes(claim.claim_status)) {
    return "approved";
  }

  return "review";
}

export function ClaimItemsList({ items, claim, t }) {
  if (!items?.length) {
    return null;
  }

  return (
    <Box
      mb="16px"
      sx={{
        border: "1px solid #C5D0E0",
        borderRadius: "12px",
        overflow: "hidden",
        backgroundColor: baseTheme.colors.neutral,
      }}
    >
      <Typography
        fontWeight={700}
        fontSize="1.05rem"
        color={baseTheme.colors.text}
        sx={{ padding: "16px 16px 0" }}
      >
        {t("status.claimItems")}
      </Typography>
      <Box>
        {items.map((item) => {
          const itemStatus = getItemStatus(item, claim);
          const isApproved = itemStatus === "approved";

          return (
            <Box
              key={item.line_item_id}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              gap="12px"
              sx={{
                padding: "14px 16px",
                borderBottom: "1px solid #E2E8F0",
                "&:last-child": { borderBottom: "none" },
              }}
            >
              <Box display="flex" alignItems="center" gap="12px" minWidth={0}>
                {item.image_url ? (
                  <Box
                    component="img"
                    src={item.image_url}
                    alt=""
                    sx={{
                      width: 48,
                      height: 48,
                      borderRadius: "8px",
                      objectFit: "cover",
                      flexShrink: 0,
                    }}
                  />
                ) : null}
                <Box minWidth={0}>
                  <Typography fontWeight={600} fontSize="15px" noWrap>
                    {item.product_name || item.line_item_id}
                  </Typography>
                  <Typography fontSize="14px" color={META_TEXT}>
                    Qty {item.quantity}
                    {item.price != null
                      ? ` · ${formatMoney(item.price, claim.order?.currency)}`
                      : ""}
                  </Typography>
                </Box>
              </Box>
              <Chip
                size="small"
                label={
                  isApproved
                    ? t("status.itemStatusApproved")
                    : t("status.itemStatusReview")
                }
                sx={{
                  backgroundColor: isApproved ? "#E8F5EC" : "#FFF3D6",
                  color: isApproved ? "#145C2B" : "#5C3D00",
                  fontWeight: 600,
                  flexShrink: 0,
                }}
              />
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
